import { render, staticRenderFns } from "./RightContainer2.vue?vue&type=template&id=3c5fe8aa&scoped=true&"
import script from "./RightContainer2.vue?vue&type=script&lang=js&"
export * from "./RightContainer2.vue?vue&type=script&lang=js&"
import style0 from "./RightContainer2.vue?vue&type=style&index=0&id=3c5fe8aa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5fe8aa",
  null
  
)

export default component.exports